module.exports = __webpack_public_path__ + "static/img/V6.b917b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/V6.png
// module id = Iha/
// module chunks = 1